import React from 'react'
import { SupplierDiscoveryInformationStyle } from './styled'
import { SupplierDiscoverySection } from './SupplierDiscoverySection'
import { EarningStatementTable } from './EarningStatementTable'
import { FinancialStatementTable } from './FinancialStatementTable'
import { FinancialRatioTable } from './FinancialRatioTable'
import {
  Button,
  Image,
  Section,
  Tabber,
  Accordion,
  Input,
  InputTextarea,
  BarChart,
  Breadcrumbs,
  NewBlock,
  Spinner,
  Loading,
} from '../../components'
import ReactTooltip from 'react-tooltip'
import { ICONS, CONTENTS } from '../../themes'

import {
  supplierController,
  comprehensiveAssessmentController,
} from '../../apiService'
import {
  ROUTE_PATH,
  STRING,
  dateMonDayYearTime,
  toastActive,
  toastFail,
  localStorageService,
} from '../../helpers'
import Moment from 'moment'
import FileDownload from 'js-file-download'
import { HighLight } from '../../helpers/highLight'
import { toInteger, upperCase } from 'lodash'
import { regulatory } from '../../components/Breadcrumbs/linkList'
import Loader from 'react-spinners/BarLoader'

const storageService = localStorageService.getService()

export class SupplierDiscoveryInformationContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      supplier: [],
      supplierSustainability: [],
      supplierNew: [],
      isLoading: false,
      accordions: [
        { name: 'food', isOpen: true },
        { name: 'it', isOpen: true },
      ],
      offline: [],
      onlines: [],
      accordionFood: [],
      industryTagNews: [],
      relevantTagNews: [],
      tabberIndex: 0,
      tabberIndex_2: 2,
      tabberIndexNews: 0,
      showReadmore: false,
      showButtonBack: false,
      defaultTextLenght: 250,
      regulatory: false,
      credenUrl: '',
      credenUpdate: '',

      newsPage: 1,
      newsLimit: 10,
      newsTotalPage: 0,
      isBottom: true,
      isGetImage: false,
    }
  }
  componentWillUnmount() {
    this._isMounted = false
    window.removeEventListener('scroll', this._handleScroll)
  }

  _handleScroll = async () => {
    const docElm = document.documentElement
    const scrollBottom =
      docElm.scrollHeight - (docElm.scrollTop + docElm.clientHeight)
    if (
      scrollBottom < 1 &&
      this.state.tabberIndex == 6 &&
      this.state.isBottom &&
      this.state.newsPage < this.state.newsTotalPage &&
      !this.state.isGetImage
    ) {
      await this.setState({
        isBottom: false,
        newsPage: this.state.newsPage + 1,
      })
      this._fetchSupplierNew()
    }
  }

  componentDidMount = async () => {
    this.setState({ loading: true })
    window.addEventListener('scroll', this._handleScroll.bind(this))
    this._isMounted = true
    await this._fetchSupplierId()
    await this._fetchSupplierRegulatory()
    await this._fetchSupplierSustainability()
    await this._fetchSupplierNew()
    await this._fetchOfflineByID()
    await this._fetchOnlineByID()
    await this._fetchTagBySuppilerID()
    this.buttonBackActive()
    this.setState({ loading: false })
  }

  buttonBackActive = () => {
    const { location } = this.props
    if (location && location.state) {
      if (location.state.showButtonBack) {
        if (this._isMounted) {
          return this.setState({ showButtonBack: true })
        }
      } else {
        if (this._isMounted) {
          return this.setState({ showButtonBack: false })
        }
      }
    }
  }

  componentDidUpdate() {
    // this.getReadmore()
  }

  getReadmore = () => {
    const newsIndex = 6
    if (this.state.tabberIndex === newsIndex) {
      this.showReadmore()
    }
  }

  toggleDataAccordion = evtName => {
    if (this._isMounted) {
      return this.setState(prevState => ({
        ...prevState,
        accordions: prevState.accordions.map(accordion => ({
          ...accordion,
          isOpen:
            accordion.name === evtName ? !accordion.isOpen : accordion.isOpen,
        })),
      }))
    }
  }

  toggleDataAccordionFood = indexOffline => {
    if (this._isMounted) {
      return this.setState(prevState => {
        const { accordionFood } = prevState
        let accordionFoodNew = accordionFood
        accordionFoodNew = [
          ...accordionFoodNew,
          (accordionFoodNew[indexOffline] = {
            ...accordionFoodNew[indexOffline],
            isOpen: !accordionFoodNew[indexOffline].isOpen,
          }),
        ]
        return accordionFoodNew
      })
    }
  }

  _fetchTagBySuppilerID = async () => {
    try {
      const id = this.props.match.params.id
      if (id) {
        const res = await supplierController().getSupulierTag(id)
        if (res) {
          const industryNews = res.IndustryNews
            ? res.IndustryNews.map(tag => tag.name)
            : []
          const relevantNews = res.RelevantNews
            ? res.RelevantNews.map(tag => tag.name)
            : []
          if (this._isMounted) {
            this.setState({
              industryTagNews: industryNews,
              relevantTagNews: relevantNews,
            })
          }
        } else {
          this.props.history.goBack()
        }
      }
    } catch (error) {
      throw ('get supulier tag fail', error)
    }
  }

  _fetchSupplierId() {
    supplierController()
      .supplierListId(this.props.match.params.id)
      .then(res => {
        // console.log('_fetchSupplierId', res)
        if (res) {
          let tabberIndex = 0
          if (!res.financial_info) {
            tabberIndex = 99999
          }
          if (this._isMounted) {
            this.setState({ supplier: res, isLoading: true, tabberIndex })
          }
          if (res.srm_page) {
            this.setState({
              credenUrl: res.srm_page.url,
              credenUpdate: res.last_updated_from_creden,
            })
          }
        }
      })
      .catch(e => {
        console.log(e.message)
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ isLoading: true })
        }
      })
  }

  _fetchSupplierRegulatory() {
    supplierController()
      .supplierRegulatory(this.props.match.params.id)
      .then(res => {
        // console.log('_fetchSupplierRegulatory', res)
        if (this._isMounted) {
          if (res.code_of_practice) {
            this.setState({ regulatory: true })
          } else {
            this.setState({ regulatory: false })
          }
        }
      })
      .catch(e => {
        console.log(e.message)
      })
  }

  _fetchSupplierSustainability() {
    supplierController()
      .supplierSustainability(this.props.match.params.id)
      .then(res => {
        if (this._isMounted) {
          // console.log({ res })
          this.setState({ supplierSustainability: res })
        }
      })
      .catch(e => {
        console.log(e.message)
      })
  }

  _fetchSupplierNew() {
    let params = {
      page: this.state.newsPage,
      limit: this.state.newsLimit,
    }
    supplierController()
      .supplierNew(this.props.match.params.id, params)
      .then(async res => {
        if (res) {
          if (res.records.IndustryNews && res.records.RelevantNews) {
            const addReadmoreStatusIndustryNews = res.records.IndustryNews.map(
              news => {
                return { showMore: false, ...news }
              }
            )
            const addReadmoreStatusRelevantNews = res.records.RelevantNews.map(
              news => {
                return { showMore: false, ...news }
              }
            )
            // const newObj = {
            //   IndustryNews: addReadmoreStatusIndustryNews,
            //   RelevantNews: addReadmoreStatusRelevantNews,
            // }
            if (this._isMounted) {
              if (this.state.newsPage > 1) {
                const newObj = {
                  IndustryNews: [
                    ...this.state.supplierNew.IndustryNews,
                    ...addReadmoreStatusIndustryNews,
                  ],
                  RelevantNews: [
                    ...this.state.supplierNew.RelevantNews,
                    ...addReadmoreStatusRelevantNews,
                  ],
                }
                await this.setState({
                  supplierNew: newObj,
                  newsPage: res.page,
                  newsTotalPage: res.total_page,
                  isBottom: true,
                })
              } else {
                const newObj = {
                  IndustryNews: addReadmoreStatusIndustryNews,
                  RelevantNews: addReadmoreStatusRelevantNews,
                }
                await this.setState({
                  supplierNew: newObj,
                  newsPage: res.page,
                  newsTotalPage: res.total_page,
                  isBottom: true,
                })
              }
              if (!this.state.isGetImage) {
                // this.getImageNews()
                this.setState({ isGetImage: true })
              }
            }
          }
        }
      })
  }

  getImageNews = async () => {
    const newSupplierNew = this.state.supplierNew
    let newRelevantNews = [...this.state.supplierNew.RelevantNews]
    let newIndustryNews = [...this.state.supplierNew.IndustryNews]
    let countRelevantNews = 0
    let countIndustryNews = 0
    for (var i = 0; i < newRelevantNews.length; i++) {
      let obj = { ...newRelevantNews[i] }
      let tokens = storageService.getAccessToken()
      if (obj.image == '' && tokens) {
        const params = {
          link: newRelevantNews[i].link,
        }
        try {
          await supplierController()
            .supplierNewImage(params)
            .then(res => {
              if (
                res &&
                res.status == 200 &&
                res.data &&
                res.data.result != ''
              ) {
                obj.image = res.data.result
                newRelevantNews[i] = obj
              }
            })
        } catch {
          console.log('get news image error')
        }
      }
      countRelevantNews = countRelevantNews + 1
    }
    for (var l = 0; l < newIndustryNews.length; l++) {
      let obj = { ...newIndustryNews[l] }
      let tokens = storageService.getAccessToken()
      if (obj.image == '' && tokens) {
        const params = {
          link: newIndustryNews[l].link,
        }
        try {
          await supplierController()
            .supplierNewImage(params)
            .then(res => {
              if (
                res &&
                res.status == 200 &&
                res.data &&
                res.data.result != ''
              ) {
                obj.image = res.data.result
                newIndustryNews[l] = obj
              }
            })
        } catch {
          console.log('get news image error')
        }
      }
      countIndustryNews = countIndustryNews + 1
    }
    if (
      newRelevantNews.length == countRelevantNews &&
      newIndustryNews.length == countIndustryNews
    ) {
      const objSupplierNew = {
        RelevantNews: newRelevantNews,
        IndustryNews: newIndustryNews,
      }
      // console.log('objSupplierNew', objSupplierNew)
      this.setState({ supplierNew: objSupplierNew, isGetImage: false })
    }
  }

  _fetchOfflineByID = async () => {
    try {
      const id = this.props.match.params.id

      if (!id) return
      const res = await comprehensiveAssessmentController().getOfflineAssessmentID(
        id,
        'desc'
      )
      // console.log('_fetchOfflineByID', res)
      if (res) {
        // const accordionFood = res.map((value, index) => {
        //   return { isOpen: true, id: index, name: 'food' }
        // })
        if (this._isMounted) {
          this.setState({
            offline: res,
            // accordionFood,
          })
        }
      }
    } catch (error) {
      throw error
    }
  }

  _fetchOnlineByID = async () => {
    try {
      const id = this.props.match.params.id

      if (!id) return
      const res = await comprehensiveAssessmentController().getOnlineAssessmentID(
        id
      )
      // console.log('_fetchOnlineByID', res)
      if (res) {
        if (this._isMounted) {
          this.setState({
            onlines: res,
          })
        }
      }
    } catch (error) {
      throw error
    }
  }

  _downloadAssessments = async (id, name) => {
    return (
      comprehensiveAssessmentController()
        .downloadAssessments(id)
        // .then(res => FileDownload(res))
        .then(res => FileDownload(res.data, name))
    )
  }

  _handleClickLists = link => {
    window.open(link, '_blank')
    return false
  }

  onClickShowMore = (event, index, key = 'RelevantNews') => {
    event.stopPropagation()
    const elementNewsContainer = document.getElementById(
      'data_description_container' + index
    )
    elementNewsContainer.classList.remove('is-ellipsis')
    if (this._isMounted) {
      return this.setState(prevState => {
        const { supplierNew } = prevState
        const newObj = {
          ...supplierNew,
          [key]: [
            ...supplierNew[key],
            (supplierNew[key][index] = {
              ...supplierNew[key][index],
              showMore: true,
            }),
          ],
        }
        return newObj
      })
    }
  }

  _updateCreden(supplierDiscoveryId) {
    supplierController()
      .supplierUpdate(supplierDiscoveryId)
      .then(res => {
        if (res.status == 'UpdateSuccess') {
          setTimeout(() => {
            toastActive('Update success')
            this._fetchSupplierId()
          }, 1000)
        } else {
          toastFail('Update fail')
        }
      })
      .catch(e => {
        console.log(e.message)
      })
  }

  renderListNews = (supplierNews = [], tagHighlight = [], key) => {
    if (Array.isArray(supplierNews) && this.state.tabberIndex === 6) {
      return supplierNews.map((item, index) => {
        return this.renderNewsDescription(item, index, tagHighlight, key)
      })
    }
  }

  showReadmore = () => {
    const { tabberIndexNews } = this.state
    let newsList = []
    if (tabberIndexNews === 0) {
      newsList = this.state.supplierNew.RelevantNews
    } else {
      newsList = this.state.supplierNew.IndustryNews
    }
    if (newsList && newsList.length > 0) {
      newsList.map((item, index) => {
        const elementNews = document.getElementById('data_description' + index)
        const elementLabel = document.getElementById(
          'label_description' + index
        )
        const elementNewsContainer = document.getElementById(
          'data_description_container' + index
        )
        let showReadmore = false
        if (elementNews) {
          const elementNewsHeight = elementNews.clientHeight
          const DEFAULT_LINEHEIGHT = 1.55 * 17
          const labelDescriptionHeight = elementLabel.clientHeight
            ? elementLabel.clientHeight
            : DEFAULT_LINEHEIGHT
          const countLine = 2

          if (elementNewsHeight) {
            showReadmore =
              elementNewsHeight / labelDescriptionHeight > countLine
            if (showReadmore && !item.showMore) {
              elementNewsContainer.classList.add('is-ellipsis')
            }
          }
        }
      })
    }
  }

  renderNewsDescription = (item = {}, index, tagHighlight = [], key) => {
    return (
      <>
        {/* <div
          className="lists"
          key={item.title}
          onClick={() => this._handleClickLists(item.link)}
        >
          <div className="list public-date-row">
            <div className="label">Public Date:</div>
            <div className="data">
              {Moment(item.pubDate).format('DD/MM/YYYY')}
            </div>
          </div>

          <div className="list title-row">
            <div className="label">Title:</div>
            <div className="data">
              <HighLight
                highlightClassName="highlight"
                textToHighlight={item.title}
                searchWords={tagHighlight}
              />
            </div>
          </div>
          <div className="list description-row">
            <div className="label" id={'label_description' + index}>
              Description:
            </div>

            <div
              id={'data_description_container' + index}
              className={`data ${
                item.description.trim().length > this.state.defaultTextLenght &&
                'is-ellipsis'
              }`}
            >
              <div className="data-wrapper" id={'data_description' + index}>
                <HighLight
                  highlightClassName="highlight"
                  textToHighlight={item.description}
                  searchWords={tagHighlight}
                />
              </div>

              <Button
                className="readmore link"
                onClick={e => this.onClickShowMore(e, index, key)}
              >
                ...Readmore
              </Button>
            </div>
          </div>
          <div className="list severity-row">
            <div className="label">Source:</div>
            <div className="data">{item.source}</div>
          </div>
        </div> */}
        <NewBlock
          // id={item.id}
          // key={item.title}
          onClick={() => this._handleClickLists(item.link)}
          title={item.title}
          metaName={item.source}
          dateTime={this.timeAgo(new Date(item.pubDate))}
          srcImage={item.image ? item.image : CONTENTS['astro.png']}
          // srcImage="//t1.gstatic.com/images?q=tbn:ANd9GcS7OWziKD2Lc3zReERlqVcffAcgIuzzq723AR4zF807dKuqhzMY6EUEpQyzwGzHXpE05gGtFHNC"
          description={
            item.description
            // 'Regrettably, they are examples of food fraud that are perpetrated on unsuspecting Americans. The global food industry loses $10 billion to $15 billion per year through food substitutions, dilutions and fake labels, according to the Grocery ...'
          }
          tagHighlight={tagHighlight}
        />
      </>
    )
  }
  timeAgo = date => {
    var ms = new Date().getTime() - date.getTime()
    var seconds = Math.floor(ms / 1000)
    var minutes = Math.floor(seconds / 60)
    var hours = Math.floor(minutes / 60)
    var days = Math.floor(hours / 24)
    var months = Math.floor(days / 30)
    var years = Math.floor(months / 12)

    if (ms === 0) {
      return 'Just now'
    } else if (seconds < 60) {
      return seconds + ' ' + STRING.SECONDS_AGO
    } else if (minutes < 60) {
      return minutes + ' ' + STRING.MINUTES_AGO
    } else if (hours < 24) {
      return hours + ' ' + STRING.HOURS_AGO
    } else if (days < 30) {
      return days + ' ' + STRING.DAYS_AGO
    } else if (months < 12) {
      return months + ' ' + STRING.MONTHS_AGO
    } else {
      return years + ' ' + STRING.YEARS_AGO
    }
  }

  renderGradeStatus = status => {
    const newStatus = upperCase(status)
    switch (newStatus) {
      case 'A':
        return { className: 'grade green', statusName: 'A' }
      case 'B':
        return { className: 'grade green-light', statusName: 'B' }
      case 'C':
        return { className: 'grade yellow', statusName: 'C' }
      case 'D':
        return { className: 'grade red', statusName: 'D' }
      case 'PASS':
        return { className: 'grade green', statusName: 'Pass' }
      case 'FAILED':
        return { className: 'grade red', statusName: 'Failed' }
      default:
        return { className: 'grade', statusName: '-' }
    }
  }

  render() {
    const supplier = this.state.supplier || {}
    const supplierSustainability = this.state.supplierSustainability || {}
    const supplierNew = this.state.supplierNew || {}
    const supplierNewIndustryNews = this.state.supplierNew.IndustryNews || []
    const supplierNewRelevantNews = this.state.supplierNew.RelevantNews || []
    const {
      industryTagNews,
      relevantTagNews,
      showButtonBack,
      credenUrl,
      credenUpdate,
      regulatory,
      offline,
      onlines,
    } = this.state
    // const style_NEWS_Block = [
    //   {
    //     maxHeight: '85vh',
    //     width: '100%',
    //     overflow: 'hidden auto',
    //     paddingRight: '10px',
    //   },
    //   {
    //     display: 'flex',
    //     flexDirection: 'column',
    //   },
    // ]
    // console.log(offline)
    return this.state.supplier ? (
      <React.Fragment>
        <SupplierDiscoveryInformationStyle>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-supplier-discovery-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  {STRING.SUPPLIER_DISCOVERY}
                </Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
            {showButtonBack && (
              <Button
                className="theme-border btn-back"
                onClick={() => this.props.history.goBack()}
              >
                &lt; &nbsp;Back
              </Button>
            )}
          </Section>

          {/* PAGE CONTENT -
          -----------------------------------------------------
          -----------------------------------------------------
          */}

          <SupplierDiscoverySection
            supplierInfo={supplier}
            isLoading={this.state.isLoading}
            offlineTemplate={offline}
            regulatory={regulatory}
            onClickUpdate={id => this._updateCreden(id)}
            onlineTemplate={onlines}
          />

          <Section className="main-content">
            <Section className="content-body">
              {/* TABS
              -----------------------------------------------
              -----------------------------------------------
              */}
              <Section className="supplier-list-wrapper">
                <Tabber
                  className="supplier-information"
                  onSelect={index => {
                    if (this._isMounted) {
                      return this.setState({
                        tabberIndex: index,
                        tabberIndex_2: index,
                      })
                    }
                  }}
                  selectedIndex={
                    supplier.financial_info
                      ? this.state.tabberIndex
                      : this.state.tabberIndex_2
                  }
                >
                  {/* TABS HEADER
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabList>
                    {supplier.financial_info ? (
                      <Tabber.Tab>{STRING.FINANCIAL}</Tabber.Tab>
                    ) : (
                      <Tabber.Tab disabled>{STRING.FINANCIAL}</Tabber.Tab>
                    )}

                    {/* <Tabber.Tab disabled="false">
                      {STRING.SUSTAINABILITY_SCORE}
                    </Tabber.Tab> */}

                    {/* <Tabber.Tab disabled="false">{STRING.ESG_SCORE}</Tabber.Tab> */}
                    {/* <Tabber.Tab>{STRING.FINANCIAL}</Tabber.Tab> */}

                    {/* {supplier.operational == '' ? ( */}
                    <Tabber.Tab disabled>{STRING.OPERATIONAL}</Tabber.Tab>
                    {/* ) : (
                      <Tabber.Tab>{STRING.OPERATIONAL}</Tabber.Tab>
                    )} */}
                    <Tabber.Tab>{STRING.REGULATORY}</Tabber.Tab>
                    {supplierSustainability &&
                    supplierSustainability.length > 0 ? (
                      <Tabber.Tab>Sustainability</Tabber.Tab>
                    ) : (
                      <Tabber.Tab disabled>Sustainability</Tabber.Tab>
                    )}

                    {onlines.length === 0 ? (
                      <Tabber.Tab
                        disabled
                        className="react-tabs__tab long-text"
                      >
                        {STRING.ONLINE_COMPREHENSIVE}
                        <br /> {STRING.ASSESSMENT}
                      </Tabber.Tab>
                    ) : (
                      <Tabber.Tab className="react-tabs__tab long-text">
                        {STRING.ONLINE_COMPREHENSIVE}
                        <br /> {STRING.ASSESSMENT}
                      </Tabber.Tab>
                    )}

                    {offline.length === 0 ? (
                      <Tabber.Tab
                        disabled
                        className="react-tabs__tab long-text"
                      >
                        {STRING.OFFLINE_COMPREHENSIVE}
                        <br /> {STRING.ASSESSMENT}
                      </Tabber.Tab>
                    ) : (
                      <Tabber.Tab className="react-tabs__tab long-text">
                        {STRING.OFFLINE_COMPREHENSIVE}
                        <br /> {STRING.ASSESSMENT}
                      </Tabber.Tab>
                    )}

                    {supplierNewIndustryNews.length == 0 &&
                    supplierNewRelevantNews.length == 0 ? (
                      <Tabber.Tab disabled>{STRING.NEWS}</Tabber.Tab>
                    ) : (
                      <Tabber.Tab>{STRING.NEWS}</Tabber.Tab>
                    )}
                    {/* <Tabber.Tab disabled>{STRING.NEWS}</Tabber.Tab> */}
                  </Tabber.TabList>

                  {/* Tabber Panels -Financial Score-
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabPanel>
                    {credenUrl !== '' ? (
                      <Section className="style-table">
                        <Section
                          className="form-control"
                          style={{
                            height: '3200px',
                          }}
                        >
                          <iframe
                            src={credenUrl}
                            frameBorder="0"
                            scrolling="no"
                          ></iframe>
                        </Section>
                      </Section>
                    ) : (
                      <Section className="no-result">
                        <Image
                          src={ICONS['icon-wrong.svg']}
                          style={{
                            filter: 'grayscale(100%) opacity(40%)',
                          }}
                        />
                        <p>No result</p>
                      </Section>
                    )}
                    <Section
                      style={{
                        justifyContent: 'center',
                      }}
                    >
                      <Button
                        className="primary"
                        style={{ width: '300px' }}
                        onClick={() => window.open(credenUrl, '_blank')}
                        disabled={credenUrl !== '' ? false : true}
                      >
                        Click for financial information
                      </Button>
                    </Section>

                    {/* <Section
                      style={{
                        justifyContent: 'center',
                      }}
                    >
                      {credenUpdate !== '' && credenUrl !== '' && (
                        <div className="label-gray">
                          {'Last Update: ' +
                            Moment(credenUpdate).format('DD/MM/YYYY HH:mm')}
                        </div>
                      )}
                    </Section> */}
                    {/* <Tabber className="financial-score">
                      <Tabber.TabList>
                        <Tabber.Tab className="react-tabs__tab theme-pink">
                          {STRING.EARNING_STATEMENT}
                        </Tabber.Tab>

                        <Tabber.Tab className="react-tabs__tab theme-blue">
                          {STRING.FINANCIAL_STATEMENT}
                        </Tabber.Tab>

                        <Tabber.Tab className="react-tabs__tab theme-green">
                          {STRING.RATIO_FINANCIAL_STATEMENT}
                        </Tabber.Tab>
                      </Tabber.TabList>

                    

                      <Tabber.TabPanel>
                        <EarningStatementTable
                          info={
                            supplier.financial_info
                              ? supplier.financial_info
                              : null
                          }
                        />
                      </Tabber.TabPanel>

                     
                      <Tabber.TabPanel>
                        <FinancialStatementTable
                          info={
                            supplier.financial_info
                              ? supplier.financial_info
                              : null
                          }
                        />
                      </Tabber.TabPanel>

                     
                      <Tabber.TabPanel>
                        <FinancialRatioTable
                          info={
                            supplier.financial_info
                              ? supplier.financial_info
                              : null
                          }
                        />
                      </Tabber.TabPanel>
                    </Tabber> */}
                  </Tabber.TabPanel>

                  {/* Tabber Panels -Operational
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabPanel>
                    <Section className="operation lists-wrapper"></Section>
                  </Tabber.TabPanel>

                  {/* Tabber Panels -Regulatory
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabPanel>
                    {this.state.regulatory ? (
                      <Section className="code-of-practice">
                        <Image
                          src={ICONS['icon-code-of-practice-accepted.svg']}
                        />
                        <p className="accepted">Code of Practice Accepted</p>
                      </Section>
                    ) : (
                      <Section className="code-of-practice">
                        <Image
                          src={
                            ICONS['icon-code-of-practice-no-information.svg']
                          }
                        />
                        <p className="no-information">No information</p>
                      </Section>
                    )}
                  </Tabber.TabPanel>

                  {/* Tabber Panels -Sustainability
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabPanel>
                    <Tabber className="theme-sub-tabs blogs">
                      <Tabber.TabList>
                        <Tabber.Tab>Distribution by Risk Dimension</Tabber.Tab>
                      </Tabber.TabList>

                      <Tabber.TabPanel>
                        <Section className="sustainability lists-wrapper">
                          {supplierSustainability.map(item => (
                            <div
                              key={item.ID}
                              style={{ display: 'flex', width: '100%' }}
                            >
                              <div className="lists">
                                <div className="list category-row">
                                  <div className="label">Category:</div>
                                  <div className="data">
                                    {item.category_name}
                                  </div>
                                </div>

                                <div className="list risk-level-row">
                                  <div className="label">Risk Level:</div>
                                  <div className="data">{item.risk_level}</div>
                                </div>

                                <div className="list score-row">
                                  <div className="label">Score:</div>
                                  <div className="data">{item.score}</div>
                                </div>
                              </div>
                              {/* Mockup data */}
                              <BarChart
                                id={item.id}
                                fullScore={25}
                                highScore={20}
                                lowScore={10}
                                title={'Distribution by Risk Dimension'}
                                datas={[
                                  {
                                    value: parseFloat(
                                      item.corporate_sustainability_score
                                    ).toFixed(2),
                                    label: 'Corporate Sustainability',
                                  },
                                  {
                                    value: parseFloat(
                                      item.environment_score
                                    ).toFixed(2),
                                    label: 'Environmental',
                                  },
                                  {
                                    value: parseFloat(
                                      item.social_score
                                    ).toFixed(2),
                                    label: 'Social',
                                  },
                                  {
                                    value: parseFloat(
                                      item.supplier_management_score
                                    ).toFixed(2),
                                    label: 'Supplier Management',
                                  },
                                ]}
                              />
                            </div>
                          ))}
                        </Section>
                        <Section className="footerTabSustain">
                          <Button
                            className="btn-footer"
                            onClick={() =>
                              window.open(
                                'https://www.mvorisicochecker.nl/en/worldmap',
                                '_blank'
                              )
                            }
                          >
                            CSR Risk Check
                          </Button>
                          <Button
                            className="btn-footer"
                            onClick={() =>
                              window.open(
                                'https://thailandsupplychain.com/home/news',
                                '_blank'
                              )
                            }
                          >
                            Article
                          </Button>
                        </Section>
                      </Tabber.TabPanel>
                    </Tabber>
                  </Tabber.TabPanel>

                  {/* Tabber Panels -Online Comprehensive Assessment-
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabPanel>
                    <Section className="offline-comprehensive lists-wrapper">
                      {/* {console.log(onlines)} */}
                      {onlines.map((item, index) => {
                        return (
                          <Section
                            key={'offline' + item.version_responded + index}
                          >
                            <div className="lists">
                              <div className="list category-row">
                                <div className="label">Questionnaire Name:</div>
                                <div className="data">
                                  {item.questionnaire_name}
                                </div>
                              </div>

                              <div className="list risk-level-row">
                                <div className="label">
                                  Questionnaire Version:
                                </div>
                                <div className="data">
                                  {item.updated_at !== ''
                                    ? Moment(item.questionnaire_version).format(
                                        'MMM DD, YYYY h:mm a'
                                      )
                                    : 'N/A'}
                                </div>
                              </div>

                              <div className="list score-row">
                                <div className="label">
                                  Total Score:
                                  <span
                                    data-for={`total-score-${item.version_responded}${index}`}
                                    data-tip
                                  >
                                    <Button className="link no-hover cursor">
                                      <Image
                                        className="cursor-icon"
                                        src={ICONS['icon-help.svg']}
                                        alt="help"
                                      />
                                    </Button>
                                  </span>
                                  <ReactTooltip
                                    id={`total-score-${item.version_responded}${index}`}
                                    place="bottom"
                                    effect="solid"
                                    className="background-white"
                                  >
                                    <div>
                                      <b>Weight Score</b>
                                      {item.online_template_response.map(
                                        (itemRes, indexRes) => {
                                          return (
                                            <>
                                              <p>
                                                {`${itemRes.section_name} : ${itemRes.weight}`}
                                              </p>
                                            </>
                                          )
                                        }
                                      )}
                                    </div>
                                  </ReactTooltip>
                                </div>
                                <div className="data">{item.total_score}</div>
                              </div>

                              <div className="list score-row">
                                <div className="label">Update Date:</div>
                                <div className="data">
                                  {item.updated_at !== ''
                                    ? Moment(item.updated_date).format(
                                        'MMM DD, YYYY h:mm a'
                                      )
                                    : 'N/A'}
                                </div>
                              </div>

                              <div className="list category-row">
                                <div className="label">
                                  Update By:
                                  {/* <span>
                                    <Button className="link no-hover cursor">
                                      <Image
                                        className="cursor-icon"
                                        src={ICONS['icon-help.svg']}
                                        alt="help"
                                        tootipValue={'test'}
                                        useTootipFor="iiiujyh"
                                        useTootip={true}
                                      />
                                    </Button>
                                  </span> */}
                                </div>
                                <div className="data">{item.updated_by}</div>
                              </div>

                              <div className="list category-row">
                                <div className="label"></div>
                                <div className="data">
                                  <Button
                                    className="primary"
                                    style={{ width: '200px' }}
                                    onClick={() =>
                                      window.open(
                                        '/buyer-online-form-management/' +
                                          item.template_id +
                                          '/' +
                                          item.supplier_id +
                                          '/' +
                                          item.version_responded +
                                          '/' +
                                          item.version_template,
                                        '_blank'
                                      )
                                    }
                                  >
                                    Display
                                  </Button>
                                </div>
                              </div>
                            </div>

                            {/* {console.log('list', item.topic_offline_assessment)} */}
                            <BarChart
                              //fullScore={25}
                              id={index}
                              highScore={70}
                              lowScore={30}
                              title={'Distribution by Risk Dimension'}
                              datas={item.online_template_response.map(
                                subItem => ({
                                  value: subItem.score ? subItem.score : 0,
                                  label: subItem.section_name,
                                })
                              )}
                            />
                          </Section>
                        )
                      })}
                    </Section>
                  </Tabber.TabPanel>

                  {/* Tabber Panels -Offline Comprehensive Assessment-
                  -------------------------------------
                  -------------------------------------
                  */}
                  <Tabber.TabPanel>
                    <Section className="offline-comprehensive lists-wrapper">
                      {/* {console.log(offline)} */}
                      {offline.map(item => (
                        <Section key={'offline' + item.id}>
                          <div className="lists">
                            <div className="list category-row">
                              <div className="label">Template Name:</div>
                              <div className="data">{item.name}</div>
                            </div>

                            <div className="list risk-level-row">
                              <div className="label">Template Version:</div>
                              <div className="data">
                                {item.updated_at !== ''
                                  ? Moment(item.created_at).format(
                                      'MMM DD, YYYY h:mm a'
                                    )
                                  : 'N/A'}
                              </div>
                            </div>

                            <div className="list score-row">
                              <div className="label">Total Score (%):</div>
                              <div className="data">{item.total}</div>
                            </div>

                            <div className="list score-row">
                              <div className="label">Grade:</div>
                              <div
                                className={
                                  this.renderGradeStatus(item.grade).className
                                }
                              >
                                {this.renderGradeStatus(item.grade).statusName}
                              </div>
                              {/* <div className="data">Pass</div> */}
                            </div>

                            <div className="list score-row">
                              <div className="label">Update Date:</div>
                              <div className="data">
                                {item.updated_at !== ''
                                  ? Moment(item.updated_at).format(
                                      'MMM DD, YYYY h:mm a'
                                    )
                                  : 'N/A'}
                              </div>
                            </div>
                          </div>

                          {/* {console.log('list', item.topic_offline_assessment)} */}
                          <BarChart
                            //fullScore={25}
                            id={'offline' + item.id}
                            highScore={70}
                            lowScore={30}
                            title={'Distribution by Risk Dimension'}
                            datas={item.topic_offline_assessment.map(
                              subItem => ({
                                value: subItem.score
                                  ? subItem.score.toFixed(2)
                                  : 0,
                                label: subItem.name,
                              })
                            )}
                          />
                        </Section>
                      ))}
                    </Section>
                  </Tabber.TabPanel>

                  {/* Tabber Panels -News-
                  -------------------------------------
                  -------------------------------------
                  */}
                  {supplierNewRelevantNews.length === 0 ? (
                    <Tabber.TabPanel>
                      <Tabber
                        className="theme-sub-tabs blogs"
                        defaultIndex={1}
                        onSelect={index => {
                          if (this._isMounted) {
                            return this.setState({ tabberIndexNews: index })
                          }
                        }}
                      >
                        <Tabber.TabList>
                          {supplierNewRelevantNews.length === 0 ? (
                            <Tabber.Tab disabled>{STRING.RELEVANT}</Tabber.Tab>
                          ) : (
                            <Tabber.Tab>{STRING.RELEVANT}</Tabber.Tab>
                          )}

                          <Tabber.Tab>{STRING.INDUSTRY}</Tabber.Tab>
                        </Tabber.TabList>
                        <Tabber.TabPanel>
                          {this.renderListNews(
                            supplierNew.RelevantNews,
                            relevantTagNews,
                            'RelevantNews'
                          )}
                          {(!supplierNew.RelevantNews ||
                            !this.state.isBottom) && (
                            <div style={{ width: '100%' }}>
                              <Spinner />
                            </div>
                          )}
                          {/* <Section
                            className="style-table"
                            style={style_NEWS_Block[0]}
                          >
                            <div style={style_NEWS_Block[1]}>
                              {this.renderListNews(
                                supplierNew.RelevantNews,
                                relevantTagNews,
                                'RelevantNews'
                              )}
                            </div>
                          </Section> */}
                          {/* <Section className="table-header-freeze-wrapper">
                            <Table className="header-freeze">
                              <Table.TBODY>
                                {this.renderListNews(
                                  supplierNew.RelevantNews,
                                  relevantTagNews,
                                  'RelevantNews'
                                )}
                              </Table.TBODY>
                            </Table>
                          </Section> */}
                        </Tabber.TabPanel>
                        <Tabber.TabPanel>
                          {this.renderListNews(
                            supplierNew.IndustryNews,
                            industryTagNews,
                            'IndustryNews'
                          )}
                          {(!supplierNew.IndustryNews ||
                            !this.state.isBottom) && (
                            <div style={{ width: '100%' }}>
                              <Spinner />
                            </div>
                          )}
                          {/* <Section
                            className="style-table"
                            style={style_NEWS_Block[0]}
                          >
                            <div style={style_NEWS_Block[1]}>
                              {this.renderListNews(
                                supplierNew.IndustryNews,
                                industryTagNews,
                                'IndustryNews'
                              )}
                            </div>
                          </Section> */}
                        </Tabber.TabPanel>
                      </Tabber>
                    </Tabber.TabPanel>
                  ) : (
                    <Tabber.TabPanel>
                      <Tabber
                        className="theme-sub-tabs blogs"
                        defaultIndex={0}
                        onSelect={index => {
                          if (this._isMounted) {
                            return this.setState({ tabberIndexNews: index })
                          }
                        }}
                      >
                        <Tabber.TabList>
                          <Tabber.Tab>{STRING.RELEVANT}</Tabber.Tab>
                          {supplierNewIndustryNews.length === 0 ? (
                            <Tabber.Tab disabled>{STRING.INDUSTRY}</Tabber.Tab>
                          ) : (
                            <Tabber.Tab>{STRING.INDUSTRY}</Tabber.Tab>
                          )}
                        </Tabber.TabList>
                        <Tabber.TabPanel>
                          {this.renderListNews(
                            supplierNew.RelevantNews,
                            relevantTagNews,
                            'RelevantNews'
                          )}
                          {(!supplierNew.RelevantNews ||
                            !this.state.isBottom) && (
                            <div style={{ width: '100%' }}>
                              <Spinner />
                            </div>
                          )}
                          {/* <Section
                            className="style-table"
                            style={style_NEWS_Block[0]}
                          >
                            <div style={style_NEWS_Block[1]}>
                              {this.renderListNews(
                                supplierNew.RelevantNews,
                                relevantTagNews,
                                'RelevantNews'
                              )}
                            </div>
                          </Section> */}
                        </Tabber.TabPanel>
                        <Tabber.TabPanel>
                          {this.renderListNews(
                            supplierNew.IndustryNews,
                            industryTagNews,
                            'IndustryNews'
                          )}
                          {(!supplierNew.IndustryNews ||
                            !this.state.isBottom) && (
                            <div style={{ width: '100%' }}>
                              <Spinner />
                            </div>
                          )}
                          {/* <Section
                            className="style-table"
                            style={style_NEWS_Block[0]}
                          >
                            <div style={style_NEWS_Block[1]}>
                              {this.renderListNews(
                                supplierNew.IndustryNews,
                                industryTagNews,
                                'IndustryNews'
                              )}
                            </div>
                          </Section> */}
                        </Tabber.TabPanel>
                      </Tabber>
                    </Tabber.TabPanel>
                  )}

                  {/* {supplierNewRelevantNews.length !== 0 &&
                  supplierNewRelevantNews.length !== 0 ? (
                    <Tabber.TabPanel>
                      <Tabber
                        className="theme-sub-tabs blogs"
                        defaultIndex={0}
                        onSelect={index => {
                          if (this._isMounted) {
                            return this.setState({ tabberIndexNews: index })
                          }
                        }}
                      >
                        <Tabber.TabList>
                          <Tabber.Tab>{STRING.RELEVANT}</Tabber.Tab>
                          <Tabber.Tab>{STRING.INDUSTRY}</Tabber.Tab>
                        </Tabber.TabList>
                        <Tabber.TabPanel>
                          {!supplierNew.RelevantNews && (
                            <div style={{ width: '100%' }}>
                              <Spinner />
                            </div>
                          )}
                          <Section
                            className="style-table"
                            style={style_NEWS_Block[0]}
                          >
                            <div style={style_NEWS_Block[1]}>
                              {this.renderListNews(
                                supplierNew.RelevantNews,
                                relevantTagNews,
                                'RelevantNews'
                              )}
                            </div>
                          </Section>
                        </Tabber.TabPanel>
                        <Tabber.TabPanel>
                          {!supplierNew.IndustryNews && (
                            <div style={{ width: '100%' }}>
                              <Spinner />
                            </div>
                          )}
                          <Section
                            className="style-table"
                            style={style_NEWS_Block[0]}
                          >
                            <div style={style_NEWS_Block[1]}>
                              {this.renderListNews(
                                supplierNew.IndustryNews,
                                industryTagNews,
                                'IndustryNews'
                              )}
                            </div>
                          </Section>
                        </Tabber.TabPanel>
                      </Tabber>
                    </Tabber.TabPanel>
                  ) : null} */}
                  {/* <Tabber.TabPanel>
                    <Tabber>
                      <Tabber.TabList>
                        <Tabber.Tab>New</Tabber.Tab>

                        <Tabber.Tab>New</Tabber.Tab>

                        <Tabber.Tab>New</Tabber.Tab>
                      </Tabber.TabList>

                      <Tabber.TabPanel>New</Tabber.TabPanel>
                      <Tabber.TabPanel>New</Tabber.TabPanel>
                      <Tabber.TabPanel>New</Tabber.TabPanel>
                    </Tabber>
                  </Tabber.TabPanel>
                   */}
                </Tabber>
              </Section>
            </Section>
          </Section>
        </SupplierDiscoveryInformationStyle>
        <Loading loading={this.state.loading} spinner={true} />
      </React.Fragment>
    ) : null
  }
}
